const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.111,
    height: 24,
    viewBox: "0 0 23.111 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mqtdfxd0ia"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 80",
    style: {
      fill: "#9c9c9c"
    },
    d: "M0 0h23.111v24H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 299",
    style: {
      clipPath: "url(#mqtdfxd0ia)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 298"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4261",
    d: "M11.726 6.562c-2.124 0-3.1 1.307-3.1 2.19a.917.917 0 0 0 .944.931c.85 0 .5-1.258 2.108-1.258.787 0 1.416.36 1.416 1.111 0 .882-.881 1.389-1.4 1.847a3.036 3.036 0 0 0-1.054 2.484c0 .85.22 1.095.865 1.095.771 0 .928-.359.928-.67a2.086 2.086 0 0 1 .881-2.043 4.2 4.2 0 0 0 1.762-2.991c.001-1.536-1.336-2.696-3.35-2.696z",
    transform: "translate(-.32)",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4262",
    d: "M11.586 16.089a1.26 1.26 0 0 0 0 2.517 1.259 1.259 0 0 0 0-2.517z",
    transform: "translate(-.385)",
    style: {
      fill: "#9c9c9c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4263",
    d: "M20.249 4.584 13.456.515a3.614 3.614 0 0 0-3.72 0L2.942 4.584a3.907 3.907 0 0 0-1.864 3.35v8.131a3.908 3.908 0 0 0 1.864 3.35l6.794 4.069a3.614 3.614 0 0 0 3.72 0l6.794-4.069a3.908 3.908 0 0 0 1.864-3.35V7.934a3.907 3.907 0 0 0-1.865-3.35zm.058 11.481a2.013 2.013 0 0 1-.96 1.726l-6.793 4.069a1.862 1.862 0 0 1-1.916 0l-6.794-4.069a2.013 2.013 0 0 1-.96-1.726V7.934a2.013 2.013 0 0 1 .96-1.726l6.793-4.068a1.862 1.862 0 0 1 1.916 0l6.794 4.069a2.013 2.013 0 0 1 .96 1.726v8.131z",
    transform: "translate(-.04)",
    style: {
      fill: "#9c9c9c"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.9ee4da7ce83c5b098883bbebed9c6fa1.svg";
export { ForwardRef as ReactComponent };